<wj-tab-panel class="full-size-tab" style="height:100%" [selectedIndex]="0" [isAnimated]="true">
    <wj-tab>
        <a>UW Year</a>
        <div>
            <div class="layout-hbox" style="align-items: flex-start; gap: 10px">
                <div>
                    <h4>
                        <span>Underwriting Year Summary</span>
                        <div class="summary-data-block-3">
                            <label>Plan<br>GNWP</label>
                            <label>GNWP<br>in-scope</label>
                            <label>Target<br>GNWP</label>
                            <div>{{grandTotalGnwpPlan() | wijmoFormat: 'n1,,' }}</div>
                            <div>{{grandTotalGnwpInScope() | wijmoFormat: 'n1,,' }}</div>
                            <div>{{grandTotalGnwpTarget() | wijmoFormat: 'n1,,' }}</div>
                        </div>
                    </h4>
                    <wj-flex-grid #gridUwySummary style="width: auto"
                                  [allowSorting]="Wijmo.AllowSorting.None"
                                  [allowResizing]="Wijmo.AllowResizing.Columns"
                                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="false" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onUwySummaryGridInitialized(gridUwySummary)"
                    >
                    </wj-flex-grid>
                </div>
            </div>

            <div class="layout-hbox" style="align-items: flex-start; gap: 10px">

                <wj-flex-chart bindingX="name" header="Walk from NLR to Target LR (UWY)"
                               style="width: 770px; height: 400px">
                    <wj-flex-chart-axis wjProperty="axisY" [axisLine]="true" format="p0" [max]="1.0">
                    </wj-flex-chart-axis>

                    <wj-flex-chart-axis wjProperty="axisX" [labelAngle]="-30" [overlappingLabels]="Wijmo.OverlappingLabels.Show" [labelPadding]="10">
                    </wj-flex-chart-axis>

                    <wj-flex-chart-waterfall #uwyWaterfallChart name="" binding="value" [styles]="GeneraliLossRatioWaterfallChartStyle" [connectorLines]="false"
                                             [showIntermediateTotal]="true" [itemFormatter]="WaterfallChartPaletteItemFormatter"
                                             [showTotal]="false" totalLabel="Plan LR" [relativeData]="false">
                    </wj-flex-chart-waterfall>

                    <wj-flex-chart-data-label [position]="Wijmo.LabelPosition.Top" content="{label}"
                                              (rendering)="GeneraliLossRatioWaterfallChartDeltaLabelsFunction($event)">
                    </wj-flex-chart-data-label>
                </wj-flex-chart>
            </div>
        </div>
    </wj-tab>

    <wj-tab>
        <a>Financial Year</a>
        <div>
            <div class="layout-vbox" style="align-items: flex-start; gap: 10px">
                <div>
                    <h4>
                        <span>Financial Year Summary</span>
                        <div class="summary-data-block-3">
                            <label>NLR {{uwy()}}</label>
                            <label>Plan LR {{uwy()}}</label>
                            <label></label>
                            <div>{{grandTotalNlrThisUwy() | wijmoFormat: 'p1' }}</div>
                            <div>{{grandTotalPlr() | wijmoFormat: 'p1' }}</div>
                            <div style="border: none"></div>
                        </div>
                    </h4>
                    <wj-flex-grid #gridFinancialYearSummary style="width: auto"
                                  [allowSorting]="Wijmo.AllowSorting.None"
                                  [allowResizing]="Wijmo.AllowResizing.Columns"
                                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="false" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onFinancialYearSummaryGridInitialized(gridFinancialYearSummary)"
                    >
                    </wj-flex-grid>
                </div>
                <div class="layout-hbox" style="align-items: flex-start; gap: 10px">

                    <wj-flex-chart bindingX="name" header="Walk from NLR to Target LR (FY)" style="width: 770px; height: 400px">
                        <wj-flex-chart-axis wjProperty="axisY" [axisLine]="true" format="p0" [max]="1.0">
                        </wj-flex-chart-axis>

                        <wj-flex-chart-axis wjProperty="axisX" [labelAngle]="-30" [overlappingLabels]="Wijmo.OverlappingLabels.Show" [labelPadding]="10">
                        </wj-flex-chart-axis>

                        <wj-flex-chart-waterfall #fyWaterfallChart name="" binding="value" [styles]="GeneraliLossRatioWaterfallChartStyle" [connectorLines]="false"
                                                 [showIntermediateTotal]="true" [itemFormatter]="WaterfallChartPaletteItemFormatter"
                                                 [showTotal]="false" totalLabel="Plan LR" [relativeData]="false">
                        </wj-flex-chart-waterfall>

                        <wj-flex-chart-data-label [position]="Wijmo.LabelPosition.Top" content="{label}"
                                                  (rendering)="GeneraliLossRatioWaterfallChartDeltaLabelsFunction($event)">
                        </wj-flex-chart-data-label>
                    </wj-flex-chart>

                </div>

            </div>
        </div>
    </wj-tab>

    <wj-tab appAccessControl="lob.PRP" acAction="disable">
        <a>Large Loss</a>
        <div>
            <div appAccessControl="lob.PRP">
                <h4>
                    <span>Large Loss Accounts Summary</span>
                </h4>
                <wj-flex-grid #gridLlSummary style="width: auto"
                              [allowSorting]="Wijmo.AllowSorting.None"
                              [allowResizing]="Wijmo.AllowResizing.Columns"
                              [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                              [isReadOnly]="false" [autoGenerateColumns]="false"
                              appIntersectionObserver (intersectionCallback)="onLLSummaryGridInitialized(gridLlSummary)"
                >
                </wj-flex-grid>
            </div>
        </div>
    </wj-tab>
</wj-tab-panel>
